module.exports = __webpack_public_path__ + "static/media/biocertica-id-logo-black.45c28e45.svg";